module.exports = __webpack_public_path__ + "static/media/carbon.de0b65fa.jpg";